import React from 'react';
import { connect } from 'react-redux';

import { getEmployeeAttendanceListExtras } from 'src/reducers/employees/employeeAttendances';
import CommonModal from 'jbc-front/components/CommonModal';
import Button from 'jbc-front/components/Button';
import styles from './SyncWithJbcModal.scss';
import { useTranslation } from 'react-i18next';

const SyncWithJbcModal = ({ isOpen, handleHide, targetPeriodText, isSemiMonthly, handleSync, handleSyncSemiMonthly, syncTimesInfo = {} }) => {
  const { syncTimesToday = 0, maxSyncTimePerDay = 3 } = syncTimesInfo;
  const { t } = useTranslation();
  const canSyncToday = syncTimesToday < maxSyncTimePerDay;

  const renderButtons = onSync => (
    <div className={styles.confirm}>
      <Button onClick={handleHide} className="u-mr20">
        {t('features.EmployeeAttendances.components.SyncWithJbcModal.cancel')}
      </Button>
      <Button onClick={onSync} primary>
        {t('features.EmployeeAttendances.components.SyncWithJbcModal.Acquire')}
      </Button>
    </div>
  );

  const renderCloseButton = () => <Button onClick={handleHide}>{t('features.EmployeeAttendances.components.SyncWithJbcModal.Close')}</Button>;

  const getButtonComponent = () => {
    if (isSemiMonthly) {
      return canSyncToday ? renderButtons(handleSyncSemiMonthly) : renderCloseButton();
    }
    return canSyncToday ? renderButtons(handleSync) : renderCloseButton();
  };

  return (
    <CommonModal isOpen={isOpen} hideModal={handleHide} closeOnClick ariaHideApp={false}>
      <CommonModal.Header hideModal={handleHide}>{t('features.EmployeeAttendances.components.SyncWithJbcModal.Acquiring_attendance_data_from_JOBCAN_Attendance')}</CommonModal.Header>
      <CommonModal.Body>
        <div className={styles.wrap}>
          <div className={styles.targetPeriodText}>{targetPeriodText}</div>
          <div className={styles.syncTimes}>{t('features.EmployeeAttendances.components.SyncWithJbcModal.Possible_number_of_times_for_acquisition')}&nbsp;{maxSyncTimePerDay - syncTimesToday}{t('features.EmployeeAttendances.components.SyncWithJbcModal.time')}</div>
          {syncTimesToday >= maxSyncTimePerDay ? (
            <div className="u-mt30">
              <p>{t('features.EmployeeAttendances.components.SyncWithJbcModal.This_function_is_restricted_Acquisition_can_be_done_up_to_3_times_a_day')}</p>
              <p>{t('features.EmployeeAttendances.components.SyncWithJbcModal.Acquisition_times_is_reset_at_12AM_every_day')}</p>
              <p className="u-mt20">{t('features.EmployeeAttendances.components.SyncWithJbcModal.Please_contact_us_if_you_would_like_to_lift_the_restriction_within_today')}</p>
            </div>
          ) : (
            <div className="u-mt30">
              <p>{t('features.EmployeeAttendances.components.SyncWithJbcModal.Cautions')}</p>
              <ul className="m-list-notes u-mt10">
                <li>
                  {t('features.EmployeeAttendances.components.SyncWithJbcModal.Attendance_data_acquisition_can_only_be_done_for_linked_staff_Please_link_all_staff_from_staff_list_first')}
                </li>
                <li>{t('features.EmployeeAttendances.components.SyncWithJbcModal.Acquisition_may_take_time')}</li>
                <li>{t('features.EmployeeAttendances.components.SyncWithJbcModal.Acquisition_can_be_done_up_to_3_times_a_day_Acquisition_times_is_reset_at_12AM_every_day')}</li>
              </ul>
            </div>
          )}
        </div>
      </CommonModal.Body>
      <CommonModal.Footer>
        {getButtonComponent()}
      </CommonModal.Footer>
    </CommonModal>
  );
};

export default connect(state => ({
  syncTimesInfo: (getEmployeeAttendanceListExtras(state) || {}).syncTimesInfo
}))(SyncWithJbcModal);
